<template>
	<v-layout wrap>
		<v-flex xs12 v-if="isLoading">
			<div class="text-xs-center pa-5">
				<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
				<div class="caption mt-4">Bilgiler yükleniyor</div>
			</div>
		</v-flex>
		<v-flex xs12 v-if="!isLoading">
			<div class="text-xs-center">
				<v-btn color="indigo" class="white--text" @click="connectFtp()">
					<v-icon dark class="mr-2">save</v-icon> FTP'ye Bağlan
				</v-btn>
				<v-btn color="success" class="white--text" @click="connectNetmin()">
					<v-icon dark class="mr-2">account_box</v-icon> Otorum Aç
				</v-btn>
			</div>
		</v-flex>
		<v-flex xs12 v-if="!isLoading">
			<v-list class="AuthViewForDomains" subheader>
				<template v-for="(auth,authIndex) in detail.auths">
					<v-subheader :key="'auth-title'+authIndex">{{auth.name}}</v-subheader>
					<v-list-tile v-for="(item,itemIndex) in auth.items" :key="'auth-title'+authIndex+'tile'+itemIndex">
						<v-list-tile-content>
							<v-list-tile-title v-html="item.name"></v-list-tile-title>
						</v-list-tile-content>
						<v-list-tile-action>
							<v-btn class="btn-auth" small outline color="teal" v-clipboard:copy="item.auth.username"
								v-html="item.auth.username"></v-btn>
						</v-list-tile-action>
						<v-list-tile-action>
							<v-btn class="btn-auth" small outline color="teal" v-clipboard:copy="item.auth.password"
								v-html="item.auth.password"></v-btn>
						</v-list-tile-action>

					</v-list-tile>
				</template>

			</v-list>
		</v-flex>
	</v-layout> 
</template>


<script>
	export default {
		name: "AuthViewForDomains",
		props: {
			domain: String
		},
		data: () => ({
			isLoading: true,
		}),
		mounted() {
			this.loadDetails()
		},
		methods: {
			loadDetails() {
				this.isLoading = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/web/toolbar/domain/", {
					params: {
						domain: this.domain
					}
				}).then(response => {
					this.detail = response.body;
					this.isLoading = false; 
				})
			},
			connectFtp() {
				window.open(process.env.VUE_APP_API_URL + "/web/connect/ftp/?method=webmaster&link=http://" + this.domain,
					"_blank");
			},
			connectNetmin() {
				window.open(process.env.VUE_APP_API_URL + "/web/connect/netmin/?method=webmaster&link=http://" + this.domain,
					"_blank");
			}
		}
	}
</script>

<style lang="less">
	.AuthViewForDomains {
		.v-list__tile {
			height: auto !important;
			padding-top: 2px;
			padding-bottom: 2px;
		}

		.v-list__tile__title {
			color: #bbb;
			font-size: 14px;
			font-style: italic;
		}

		.btn-auth {
			margin-right: 5px;
			width: 120px;
			font-size: 11px;
		}

		.btn-auth-action {
			min-width: 40px;
			box-shadow: none !important;

			.v-icon {
				font-size: 18px;
			}
		}
	}
</style>